import { useAlert } from '@/composable/message-dialog';
import { i18nGlobal as i18n } from '@/i18n';
import Waiting from '@/store/waiting';

const showSisenseUserCreateAlert = async (data) => {
  if (data?.sisenseUserCreateMessage == null) return;
  const { alert } = await useAlert();
  await alert({
    title: i18n.t('general.error'),
    message: `${i18n.t('sisense.createUserFailed')}\n${data.sisenseUserCreateMessage}`,
  });
};
const showSisenseUserDeleteAlert = async (data) => {
  if (data?.sisenseUserDeleteMessage == null) return;
  const { alert } = await useAlert();
  await alert({
    title: i18n.t('general.error'),
    message: `${i18n.t('sisense.deleteUserFailed')}\n${data.sisenseUserDeleteMessage}`,
  });
};

export default class UserActions {
  constructor (Api, types) {
    const actions = {
      async getUsersAction ({ commit }, args) {
        await waiting.check('getUsersAction', async () => {
          try {
            const res = await Api.getUsers(args);
            commit(types.SET_USERS, Object.values(res.data)[0]);
          } catch (err) {
            commit(types.CLEAR_USERS);
            throw err;
          }
        });
      },
      async getUserAction ({ commit }, args) {
        await waiting.check('getUserAction', async () => {
          try {
            const res = await Api.getUser(args);
            commit(types.SET_USER, Object.values(res.data)[0]);
          } catch (err) {
            commit(types.CLEAR_USER);
            throw err;
          }
        });
      },
      async createUserAction ({ commit }, args) {
        await waiting.check('createUserAction', async () => {
          const { data } = await Api.createUser(args);
          await showSisenseUserCreateAlert(data);
          try {
            const res = await Api.getUsers(args);
            commit(types.SET_USERS, Object.values(res.data)[0]);
          } catch (err) {
            throw err;
          }
        });
      },
      async updateUserAction ({ commit }, args) {
        await waiting.check('updateUserAction', async () => {
          const { data } = await Api.updateUser(args);
          await showSisenseUserCreateAlert(data);
          await showSisenseUserDeleteAlert(data);
          try {
            const res = await Api.getUsers(args);
            commit(types.SET_USERS, Object.values(res.data)[0]);
          } catch (err) {
            throw err;
          }
        });
      },
    };
    const waiting = new Waiting(actions);
    this.actions = actions;
  }
}
